'use strict'

const getBreakpoint = () => window.getComputedStyle(document.body, ':after').getPropertyValue('content').replace(/["'\s]/g, "");
const isSmall = () => ['xs', 'sm'].some((bp) => bp === getBreakpoint());
const isMedium = () => 'md' === getBreakpoint();
const isLarge = () => ['lg', 'xl'].some((bp) => bp === getBreakpoint());

module.exports = {
    responsive: {
        getBreakpoint: getBreakpoint,
        isSmall: isSmall,
        isMedium: isMedium,
        isLarge: isLarge
    }
}
